import React from 'react'
import { useHistory } from 'react-router-dom'
import { Menubar, MenubarNavItem } from 'components/Zui'
import { IconUserDetails } from 'components/Zui/Icon'

const Navbar = () => {
    const history = useHistory()
    const path = history.location.pathname.split('/')
    const handleMenuSelected = e => history.push(e.detail.value)

    return (
        <div className="side-drawer-wrapper">
            <div className="side-drawer">
                <Menubar
                    style={{ height: '100%' }}
                    variant="primary"
                    selected={path[1] || '/'}
                    onMenubarSelected={handleMenuSelected}
                >
                    <MenubarNavItem value="surgical-cloud">
                        <IconUserDetails slot="icon"></IconUserDetails>
                        ZEISS Surgical Cloud
                    </MenubarNavItem>
                </Menubar>
            </div>
        </div>
    )
}

export default React.memo(Navbar)
